import React from 'react';

import { NoticeStore } from './store';

export const NoticeContext = React.createContext({} as NoticeStore);
